const SMART_PUNCTUATION_REPLACEMENTS = new Map([
    ['\u2018', "'"],
    ['\u2019', "'"],
    ['\u201A', "'"],
    ['\u201B', "'"],
    ['\u2032', "'"],
    ['\u201C', '"'],
    ['\u201D', '"'],
    ['\u201E', '"'],
    ['\u2033', '"'],
    ['\u2010', '-'],
    ['\u2011', '-'],
    ['\u2012', '-'],
    ['\u2013', '-'],
    ['\u2014', '-'],
    ['\u2015', '-'],
    ['\u2212', '-'],
    ['\u2026', '...'],
]);

const LATIN_CHARACTER_REPLACEMENTS = new Map([
    ['Æ', 'AE'],
    ['æ', 'ae'],
    ['Œ', 'OE'],
    ['œ', 'oe'],
    ['Ø', 'O'],
    ['ø', 'o'],
    ['Ð', 'D'],
    ['ð', 'd'],
    ['Þ', 'Th'],
    ['þ', 'th'],
    ['Ł', 'L'],
    ['ł', 'l'],
    ['ß', 'ss'],
]);

export function normalizeEnglishTextForTts(text) {
    const normalizedPunctuation = Array.from(String(text || ''))
        .map(ch => SMART_PUNCTUATION_REPLACEMENTS.get(ch) ?? ch)
        .join('');

    return Array.from(normalizedPunctuation.normalize('NFD'))
        .filter(ch => !/[\u0300-\u036f]/u.test(ch))
        .map(ch => LATIN_CHARACTER_REPLACEMENTS.get(ch) ?? ch)
        .join('');
}
